
































































import { Component, Vue } from 'vue-property-decorator';
import _get from 'lodash/get'

@Component
export default class User extends Vue {
  loading: boolean = true
  columns = [
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      sorter: true,
    },
    {
      title: 'Active',
      dataIndex: 'active',
      sorter: true,
      scopedSlots: { customRender: 'active' },
    },
    {
      title: 'Email Verification',
      dataIndex: 'verified',
      sorter: true,
      scopedSlots: { customRender: 'verification' },
    },
    {
      title: 'Last Login',
      dataIndex: 'lastLogin',
      sorter: true,
    },
    {
      title: 'Last IP',
      dataIndex: 'lastIp',
    },
    {
      title: 'Created On',
      dataIndex: 'created_at',
      sorter: true,
    },
    {
      title: 'Action',
      dataIndex: 'operation',
      fixed: 'right',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ]
  modalVisible: boolean = false
  modalTitle: string = 'Create User'
  modalLoading: boolean = false
  form: any = {}
  isEdit: boolean = false
  rules: any = {
    email: [
      { required: true, message: 'Email must not be empty', trigger: 'blur' },
    ],
    name: [
      { required: true, message: 'Name must not be empty', trigger: 'blur' },
    ],
    role: [
      { required: true, message: 'Role must not be empty', trigger: 'blur' },
    ],
    org: [
      { required: true, message: 'Organization must not be empty', trigger: 'blur' },
    ]
  }

  get role() {
    return this.$store.state.userStore.role
  }

  get users() {
    return this.$store.state.userStore.users
  }

  get total() {
    return this.$store.state.userStore.total
  }

  get pagination() {
    return this.$store.state.userStore.pagination
  }

  get organizationList() {
    return this.$store.state.organizationStore.organizationList
  }

  get organization() {
    return this.$store.state.userStore.organization
  }

  set organization(val) {
    this.$store.commit('updateCurrentUserOrg', val)
  }
  
  mounted() {
    this.loading = true
    this.$store.dispatch('getUsers', {
      page: this.pagination.current,
      limit: this.pagination.pageSize
    }).then(() => {
      this.loading = false
      this.pagination.total = this.total
    })
    .catch(() => {
      this.loading = false
    })
  }

  updateUsers(pagination:any, filters:any, sorter:any) {
    this.loading = true
    this.$store.commit('updateUserPagination', {current: pagination.current})
    this.$store.commit('updateUserSorter', {field: sorter.field, order: sorter.order === 'ascend'? 'asc': 'desc'})
    this.$store.dispatch('getUsers').then(() => {
      this.loading = false
    })
  }

  search() {
    this.loading = true
    this.$store.commit('updateUserPagination', {current: 1})
    this.$store.dispatch('getUsers').then(() => {
      this.loading = false
    })
  }

  activate(id: string, active: boolean) {
    this.loading = true
    this.$store.dispatch('activateUser', {id, active}).then(() => {
      this.loading = false
    })
  }

  showActivation(user: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Activation',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to activate ',
        h('strong', user.email),
        '?'
      ]),
      onOk() {
        _this.activate(user.id, true)
      }
    })
  }

  showDeactivation(user: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'Deactivation',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to deactivate ',
        h('strong', user.email),
        '?'
      ]),
      onOk() {
        _this.activate(user.id, false)
      }
    })
  }

  showDeletion(user: any) {
    const h = this.$createElement
    const _this = this
    this.$confirm({
      title: 'User Delete',
      okText: 'Confirm',
      content: h('div', {}, [
        'Are you sure you want to delete ',
        h('strong', user.email),
        '?'
      ]),
      onOk() {
        _this.$store.dispatch('deleteUser', user.id)
      }
    })
  }

  showEditUser(user: any) {
    this.modalVisible = true
    this.modalTitle = 'Edit User'
    this.isEdit = true
    this.form = { ...user }
  }

  showCreateUser() {
    this.modalVisible = true
    this.modalTitle = 'Create User'
    this.isEdit = false
    this.form = {
      active: 0 
    }
  }

  saveUser() {
    this.modalLoading = true
    if (this.isEdit) {
      return this.$store.dispatch('updateUser', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("User Updated")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(JSON.stringify(_get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
    else {
      return this.$store.dispatch('addUser', this.form).then(() => {
        this.modalLoading = false
        this.modalVisible = false
        this.form = {}
        this.$message.success("User Created")
      })
      .catch(e => {
        this.modalLoading = false
        this.$message.error(_get(e, 'response.data.messages.email', _get(e, 'response.data.messages', 'Something went wrong')))
      })
    }
  }

  cancelForm() {
    this.form = {}
    this.modalVisible = false
    this.modalLoading = false
  }

}
